import { SUBSTATUS } from "Services/Status/Substatus.types";
import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import { API_URL } from "Store/Shared/Middleware/API/Constants";
import ACTIONS, { CONTACT, FETCH_ALL_CONTACT, FETCH_CONTACT, FETCH_CONTACT_DATASET, SAVE_CONTACT } from "./ActionTypes";
import { ContactId } from "./PropTypes";

export const fetchContactOverviewByPagenumber = (
    overview_fields: string[],
    pageNumber: number = 1,
    filters: any = false,
    forceFetch: boolean = false
): ACTION_TYPE => {
    let flattenFilters = '';
    const filterKeys = Object.keys(filters);
    if (filterKeys) {
        for (const filterKey of filterKeys) {
            let values = filters[filterKey];
            if (Array.isArray(filters[filterKey])) {
                values = values.join(',');
            }
            flattenFilters += `&filter[${filterKey}]=${values}`;
        }
    }

    return {
        types: getActionTypes(ACTIONS.FETCH_CONTACT_OVERVIEW_PAGE),
        shouldCallAPI: ({ candidates }) => forceFetch || !candidates._isFetchingPage.includes(pageNumber),
        callAPI: {
            url: `/api/v2/overview?entity=contact&page=${pageNumber}&overview_fields=${overview_fields ?? ''}${flattenFilters}`
        },
        payload: {
            page_number: pageNumber,
            isFiltering: flattenFilters.length > 0
        }
    }
}

export const deleteContact = (id: ContactId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_CONTACT),
    callAPI: {
        method: 'DELETE',
        url: `/api/v2/contacts/${id}`
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
        [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
    },
});

export const createContact = (data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_CONTACT),
    callAPI: {
        method: 'POST',
        url: '/api/v2/contacts',
        body: data
    }
});

export const fetchContactConcept = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_CONTACT_CONCEPT),
    shouldCallAPI: state => state.contacts._forceFetch,
    callAPI: { url: `/api/v2/contacts?substatus=${SUBSTATUS.ACTIVE.RECORD_CONCEPT}` }
});





export const fetchAllContactsV2 = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_ALL_CONTACTS),
    shouldCallAPI: state => state.contacts._forceFetch,
    callAPI: {
        url: '/api/v2/contacts'
    }
});

export const fetchContactV2 = (id: ContactId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_CONTACT),
    callAPI: {
        url: `/api/v2/contacts/${id}`
    },
    callback: fetchContactValues(id)
});

export const fetchContactValues = (id: ContactId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_CONTACT_VALUES),
    callAPI: {
        url: `/api/v2/contacts/${id}/values`
    }
});

export const createContactValues = (id: ContactId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_CONTACT_VALUES),
    callAPI: {
        method: 'POST',
        url: `/api/v2/contacts/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: fetchContactV2(id)
})

export const backgroundCreateContactValues = (id: ContactId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.BACKGROUND_CREATE_CONTACT_VALUES),
    callAPI: {
        method: 'POST',
        url: `/api/v2/contacts/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
});

export const updateContactValues = (id: ContactId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_CONTACT_VALUES),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/contacts/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: fetchContactV2(id)
})

export const upsertContactValues = (id: any, data: any) => ({
    types: getActionTypes(ACTIONS.UPSERT_CONTACT_VALUES),
    callAPI: {
        method: 'PUT',
        url: `/api/v2/contacts/${id}/values`,
        body: {
            values: data
        }
    }
})

export const backgroundUpdateContactValues = (id: ContactId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.BACKGROUND_UPDATE_CONTACT_VALUES),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/contacts/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
})

export const updateContact = (id: any, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_CONTACT),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/contacts/${id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: {
        types: [
            FETCH_CONTACT.REQUEST,
            FETCH_CONTACT.SUCCESS,
            FETCH_CONTACT.FAILURE
        ],
        callAPI: {
            url: `/api/contacts/${id}`
        }
    }
});









export function fetchAllContact(page, searchFilter, overviewFilter) {
    let urlParams = '';
    if (searchFilter) {
        urlParams += `&searchFilter=${searchFilter}`
    }

    Object.keys(overviewFilter)?.map((i) => {
        urlParams += `&${encodeURIComponent(i)}=${overviewFilter[i]}`;
    });
    
    return {
        types: [
            FETCH_ALL_CONTACT.REQUEST,
            FETCH_ALL_CONTACT.SUCCESS,
            FETCH_ALL_CONTACT.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/overview?entity=contact&page=${page}${urlParams}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function fetchContact(id: string) {
    return {
        types: [
            FETCH_CONTACT.REQUEST,
            FETCH_CONTACT.SUCCESS,
            FETCH_CONTACT.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/contacts/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function saveContact(candidateId: any, data: any) {
    return {
        types: [
            SAVE_CONTACT.REQUEST,
            SAVE_CONTACT.SUCCESS,
            SAVE_CONTACT.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/contacts/${candidateId}`,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            }),
        callback: fetchContactValues(candidateId)
    }
}



export function editContact(candidateId: any, fieldId: any, valueId: any, value: any) {
    return {
        type: CONTACT.EDIT,
        payload: {
            candidateId: candidateId,
            fieldId: fieldId,
            valueId: valueId,
            value: value
        }
    }
}

export function resetContact(candidateId: any, fieldIds: any) {
    return {
        type: CONTACT.RESET,
        payload: {
            candidateId: candidateId,
            fieldIds: fieldIds
        }
    }
}

export function fetchContactDataset() {
    return {
        types: [
            FETCH_CONTACT_DATASET.REQUEST,
            FETCH_CONTACT_DATASET.SUCCESS,
            FETCH_CONTACT_DATASET.FAILURE
        ],
        shouldCallAPI: (state: any) => state.contacts.datasets._forceFetch,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/contacts/dataset`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}